/**
 * A one-entry cache that only ever answers for the user who filled it.
 *
 * Signing out does not reload the page (utils/firebase.ts `signOut`), so a
 * plain module-level cache outlives the session that filled it: the next
 * person to sign in on the same tab saw the PREVIOUS user's plan badge
 * (2026-10-17: a brand-new account showed "MAX"). Keyed by Firebase uid, a
 * different user simply misses and refetches.
 */
export interface UserScopedCache<T> {
  get(uid: string | null | undefined): T | null;
  set(uid: string | null | undefined, value: T): void;
}

export function createUserScopedCache<T>(): UserScopedCache<T> {
  let entry: { uid: string; value: T } | null = null;
  return {
    get(uid) {
      return uid && entry && entry.uid === uid ? entry.value : null;
    },
    set(uid, value) {
      entry = uid ? { uid, value } : null;
    },
  };
}
